(function () {
	'use strict';

	document.addEventListener('DOMContentLoaded', function () {
		var elements = document.querySelectorAll('.u-scroll-reveal');

		if (!elements.length) {
			return;
		}

		// If IntersectionObserver or matchMedia not supported, just show everything
		var supportsIO = 'IntersectionObserver' in window;
		var prefersReducedMotion = window.matchMedia &&
			window.matchMedia('(prefers-reduced-motion: reduce)').matches;

		if (!supportsIO || prefersReducedMotion) {
			elements.forEach(function (el) {
				el.classList.add('is-inview');
			});
			return;
		}

		// -----------------------------------------------------------------------
		// IntersectionObserver: Reveal-on-scroll
		// -----------------------------------------------------------------------

		var observer = new IntersectionObserver(
			function (entries) {
				entries.forEach(function (entry) {
					var el = entry.target;

					if (entry.isIntersecting) {
						el.classList.add('is-inview');

						// If NO repeat class, unobserve after first reveal
						if (!el.classList.contains('u-scroll-reveal--repeat')) {
							observer.unobserve(el);
						}
					} else {
						// If repeat is enabled, remove inview when leaving viewport
						if (el.classList.contains('u-scroll-reveal--repeat')) {
							el.classList.remove('is-inview');
						}
					}
				});
			},
			{
				root: null,
				rootMargin: '0px 0px -10% 0px', // trigger just before fully in view
				threshold: 0.15
			}
		);

		elements.forEach(function (el) {
			observer.observe(el);
		});

		// -----------------------------------------------------------------------
		// OPTIONAL: Parallax-like continuous movement
		// -----------------------------------------------------------------------
		// To enable per-element parallax:
		//   - Add attribute: data-sr-parallax="0.25" (or any factor)
		//   - Also keep "u-scroll-reveal" so the base reveal still happens
		//
		// Behavior:
		//   - While in view, element's translateY is adjusted based on scroll
		//     and the parallax factor, layered on top of its reveal animation.
		// -----------------------------------------------------------------------

		var parallaxEls = Array.prototype.filter.call(elements, function (el) {
			return el.hasAttribute('data-sr-parallax');
		});

		if (!parallaxEls.length) {
			return;
		}

		var ticking = false;

		function updateParallax() {
			parallaxEls.forEach(function (el) {
				// Only parallax if we’ve already revealed it (optional)
				if (!el.classList.contains('is-inview')) return;

				var factor = parseFloat(el.getAttribute('data-sr-parallax')) || 0;
				var rect = el.getBoundingClientRect();
				var vh = window.innerHeight || document.documentElement.clientHeight;

				// Compute progress: 0 at top of viewport, 1 at bottom
				var progress = (rect.top + rect.height / 2) / vh;

				// Center anchor around 0 (middle of viewport)
				var offset = (progress - 0.5) * 2; // range ~[-1, 1]

				// Convert to px movement
				var translateY = offset * factor * 100; // 100px at factor=0.5, etc.

				// Use CSS var so we don't stomp the base transform
				el.style.setProperty('--sr-parallax-y', translateY.toFixed(2) + 'px');
			});

			ticking = false;
		}

		function onScroll() {
			if (!ticking) {
				window.requestAnimationFrame(updateParallax);
				ticking = true;
			}
		}

		// Initialize parallax var on elements
		parallaxEls.forEach(function (el) {
			el.style.setProperty('--sr-parallax-y', '0px');
		});

		window.addEventListener('scroll', onScroll, { passive: true });
		window.addEventListener('resize', onScroll);
		// Initial call
		onScroll();
	});
})();